import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { EnvelopeSimple } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const WeeklyReportToggle = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/media-buyer/weekly-report").then((r) => setS(r.data)).catch(() => setS(null));
  }, []);
  if (!s) return null;
  const flip = async () => {
    setBusy(true);
    try {
      const r = await api.put("/media-buyer/weekly-report", { enabled: !s.enabled });
      setS(r.data);
      toast.success(r.data.enabled ? "Weekly email turned on" : "Weekly email turned off");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't save");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="brut-card bg-white p-3 mb-6 flex flex-wrap items-center gap-3" data-testid="weekly-report-card">
      <EnvelopeSimple size={18} weight="bold" />
      <div className="flex-1 min-w-[220px]">
        <div className="font-chivo font-black uppercase text-sm tracking-tight">Weekly email</div>
        <div className="text-xs text-zinc-600">Last week's leads, sold rate and top states, {s.schedule}. No prices.</div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Switch checked={s.enabled} onCheckedChange={flip} disabled={busy} data-testid="weekly-report-toggle" />
        <span className="label-mono w-8" data-testid="weekly-report-status">{s.enabled ? "On" : "Off"}</span>
      </div>
    </section>
  );
};
